import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useBreakpoint } from "hooks/use-breakpoint";
import { Art } from "./art";
import { Actions } from "./actions";
import { Download } from "./download";
import { isMobile } from "react-device-detect";
import { useTracking } from "./tracking";
import {
  Summary,
  Title,
  Top,
  ArtContainer,
  TitleIcon,
  Item,
  AirplaneIcon,
  ChatIcon,
  SearchIcon,
  Lead,
  ApprovalContainer,
  Container,
  ApprovalText,
  TextContainer,
} from "./styles";
export function ConfirmationScreen() {
  const mdBreakpoint = useBreakpoint("md", { noSsr: true });

  const { t } = useTranslation("screens", {
    keyPrefix: "confirmation",
  });

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useTracking();

  return (
    <>
      {mdBreakpoint ? (
        <>
          <Top>
            <ArtContainer>
              <Art />
            </ArtContainer>
            <Actions />
          </Top>
          <Summary>
            <Container>
              <ApprovalContainer>
                <TitleIcon />
                <ApprovalText>{t("success")}</ApprovalText>
              </ApprovalContainer>
              <Title>{t("downloadTitle")}</Title>
            </Container>
            {!isMobile && (
              <Lead>
                <TextContainer>
                  <SearchIcon />
                  <Item>{t("appInfo.view")}</Item>
                </TextContainer>
                <TextContainer>
                  <ChatIcon />
                  <Item>{t("appInfo.chat")}</Item>
                </TextContainer>
                <TextContainer>
                  <AirplaneIcon />
                  <Item>{t("appInfo.updates")}</Item>
                </TextContainer>
              </Lead>
            )}
            <Download />
          </Summary>
        </>
      ) : (
        <>
          <Top>
            <ArtContainer>
              <Art />
            </ArtContainer>
            {!isMobile && (
              <Lead>
                <TextContainer>
                  <SearchIcon />
                  <Item>{t("appInfo.view")}</Item>
                </TextContainer>
                <TextContainer>
                  <ChatIcon />
                  <Item>{t("appInfo.chat")}</Item>
                </TextContainer>
                <TextContainer>
                  <AirplaneIcon />
                  <Item>{t("appInfo.updates")}</Item>
                </TextContainer>
              </Lead>
            )}
            <Actions />
          </Top>
          <Summary>
            <Container>
              <ApprovalContainer>
                <TitleIcon />
                <ApprovalText>{t("success")}</ApprovalText>
              </ApprovalContainer>
              <Title>{t("downloadTitleShort")}</Title>
            </Container>
            <Download />
          </Summary>
        </>
      )}
    </>
  );
}
